<template>
    <div class="wrapper">
        <nav class="navbar">
            <div class="navbar__logo">
                <router-link to="/">SpaceX</router-link>
            </div><!-- /.navbar__logo -->
            <div class="navbar__links">
                <router-link class="navbar__item" to="/about">About</router-link>
                <router-link class="navbar__item" to="/launches">Launches</router-link>
                <router-link class="navbar__item" to="/missions">Missions</router-link>
                <router-link class="navbar__item" to="/rockets">Rockets</router-link>
            </div><!-- /.navbar__links -->
        </nav><!-- /.navbar -->
    </div><!-- /.wrapper -->
</template>

<script>
export default {
    name: 'Nav',
}
</script>
